import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./Home.css";
// import EtmWrap from '../../assets/ethWrap.png'
import imge2 from "../../assets/ETHBig.png";
import imge3 from "../../assets/bnb.png";
import imge4 from "../../assets/imge1.png";
import imge5 from "../../assets/SOL.png";
import imge6 from "../../assets/imge4.png";
import img7 from "../../assets/Swatch.svg";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../footer/Footer.css";

import Footer from '../footer/Footer'
const Home = () => {
 
  // window.addEventListener('scroll', toggleVisible);
  return (
    <>
      <div>
        <div className="homeBackGroud">
          <div className="container">
            <div className="row ">
              <div className="col-md-12 ">
                <div className="homeOuter">
                  <div className="outerimages">
                    <div className="homeHeadingDiv">
                      <p className="homeHeading">Stake Calculator</p>
                    </div>
                    <div className=" homeIner">
                      <input
                        className="homePara1"
                        type="text"
                        placeholder="Enter Amount"
                      />
                      {/* <div className=''>
               <p className='homePara1'></p>
             </div> */}
                      <div className="homeSpanDiv">
                        <button className="homeSpan3"> MAX</button>
                      </div>
                    </div>
                    <div className="homeIner2">
                      <div className=" ">
                        <p className="homePara3" >
                          {" "}
                          <span className="homeSpan2">Bal: </span> <span style={{fontWeight:'500'}}>0.00 FTMA{" "}</span>
                        </p>
                      </div>
                    </div>
                    <div className="homeIner">
                      <div className="">
                        <input
                          className="homePara1"
                          type="number"
                          placeholder="Enter no.of days"
                        />
                        {/* <p className='homePara1'>Enter no.of days</p> */}
                      </div>
                    </div>
                    <div></div>
                    <div className="wrapBtnDvi"></div>
                    <button className="btn btn-success wrapBtn">
                      Calculate
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row homeRow">
              <div className="col-md-12 homeouter2">
                <div className="homeImgeAndParaDiv">
                  <div>
                    <img alt="" src={imge2} />
                  </div>
                  <div className="homeImgeAndPara1 ">
                    <p>Ethereum Mainnet</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Circulating</p>
                  </div>
                  <div>
                    <p>2440657.38 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Staked</p>
                  </div>
                  <div>
                    <p>1508960.94 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Market Cap:</p>
                  </div>
                  <div>
                    <p>576871.34 USD</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Stake Rewards: </p>
                  </div>
                  <div>
                    <p>376895.91 FMTA</p>
                  </div>
                </div>
                <div className=" homeInerDataDiv2">
                  <div>
                    <p>LP Rewards: </p>
                  </div>
                  <div>
                    <p>430792.09 FMTA</p>
                  </div>
                </div>
              </div>
              <div className="col-md-12 homeouter31">
                <div className="homeImgeAndParaDiv">
                  <div>
                    <img alt="" src={imge3} />
                  </div>
                  <div className="homeImgeAndPara1 ">
                    <p>Binance Smart Chain</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Circulating</p>
                  </div>
                  <div>
                    <p>2440657.38 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Staked</p>
                  </div>
                  <div>
                    <p>1508960.94 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Market Cap:</p>
                  </div>
                  <div>
                    <p>576871.34 USD</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Stake Rewards: </p>
                  </div>
                  <div>
                    <p>376895.91 FMTA</p>
                  </div>
                </div>
                <div className=" homeInerDataDiv2">
                  <div>
                    <p>LP Rewards: </p>
                  </div>
                  <div>
                    <p>430792.09 FMTA</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row homeRow">
              <div className="col-md-12 homeouter3">
                <div className="homeImgeAndParaDiv">
                  <div>
                    <img alt="" src={imge4} />
                  </div>
                  <div className="homeImgeAndPara1 ">
                    <p>Polygon Mainnet</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Circulating</p>
                  </div>
                  <div>
                    <p>2440657.38 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Staked</p>
                  </div>
                  <div>
                    <p>1508960.94 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Market Cap:</p>
                  </div>
                  <div>
                    <p>576871.34 USD</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Stake Rewards: </p>
                  </div>
                  <div>
                    <p>376895.91 FMTA</p>
                  </div>
                </div>
                <div className=" homeInerDataDiv2">
                  <div>
                    <p>LP Rewards:</p>
                  </div>
                  <div>
                    <p>430792.09 FMTA</p>
                  </div>
                </div>
              </div>
              <div className="col-md-12 homeouter4">
                <div className="homeImgeAndParaDiv">
                  <div>
                    <img alt="" src={imge5} />
                  </div>
                  <div className="homeImgeAndPara1 ">
                    <p>Solana</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Circulating</p>
                  </div>
                  <div>
                    <p>2440657.38 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Staked</p>
                  </div>
                  <div>
                    <p>1508960.94 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Market Cap:</p>
                  </div>
                  <div>
                    <p>576871.34 USD</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Stake Rewards: </p>
                  </div>
                  <div>
                    <p>376895.91 FMTA</p>
                  </div>
                </div>
                <div className=" homeInerDataDiv2">
                  <div>
                    <p>LP Rewards:</p>
                  </div>
                  <div>
                    <p>430792.09 FMTA</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row homeRow1">
              <div className="col-md-12 homeouter5">
                <div className="homeImgeAndParaDiv">
                  <div>
                    <img alt="" src={imge6} />
                  </div>
                  <div className="homeImgeAndPara1 ">
                    <p>Avalanche Mainnet</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Circulating</p>
                  </div>
                  <div>
                    <p>2440657.38 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Staked</p>
                  </div>
                  <div>
                    <p>1508960.94 FMTA</p>
                  </div>
                </div>
                <div className="homeInerDataDiv2">
                  <div>
                    <p>Market Cap:</p>
                  </div>
                  <div>
                    <p>576871.34 USD</p>
                  </div>
                </div>
                <div className="homeInerDataDiv1">
                  <div>
                    <p>Stake Rewards: </p>
                  </div>
                  <div>
                    <p>376895.91 FMTA</p>
                  </div>
                </div>
                <div className=" homeInerDataDiv2">
                  <div>
                    <p>LP Rewards:</p>
                  </div>
                  <div>
                    <p>430792.09 FMTA</p>
                  </div>
                </div>
              </div>
              {/* <div className='col-md-12 homeouter2'>
            <div className='homeImgeAndParaDiv'>
              <div>
                <img alt='' src={imge2} />
              </div>
              <div className='homeImgeAndPara1 '>
                <p>
                  Ethereum Mmainnet
                </p>
              </div>
            </div>
            <div className='homeInerDataDiv2'>
              <div>
                <p>Ciculating</p>
              </div>
              <div>
                <p>
                  24434345.87 FMTA
                </p>
              </div>
            </div>
            <div className='homeInerDataDiv1'>
              <div>
                <p>Staked</p>
              </div>
              <div>
                <p>
                  24434345.87 FMTA
                </p>
              </div>
            </div>
            <div className='homeInerDataDiv2'>
              <div>
                <p>Market Cap:</p>
              </div>
              <div>
                <p>
                  24434345.87 FMTA USD
                </p>
              </div>
            </div>
            <div className='homeInerDataDiv1'>
              <div>
                <p>Stake Rewards</p>
              </div>
              <div>
                <p>
                  24434345.87 FMTA
                </p>
              </div>
            </div>
            <div className=' homeInerDataDiv2'>
              <div>
                <p>LP Rewards:</p>
              </div>
              <div>
                <p>
                  24434345.87 FMTA
                </p>
              </div>
            </div>

          </div> */}
            </div>
          </div>
          <div className="outersgsgsg">
            <img alt="" src={img7} />
          </div>
        </div>
      </div>
    <Footer/>
    </>
  );
};

export default Home;
